export const getEnvVar = (key: keyof NodeJS.ProcessEnv, defaultValue?: string): string => {
  const value = process.env[key];
  if (!value) {
    if (process.env.NODE_ENV === 'development' && defaultValue) {
      console.warn(`Environment variable ${key} is not set, using default value`);
      return defaultValue;
    }
    console.error(`Environment variable ${key} is not set`);
    throw new Error(`Environment variable ${key} is not set`);
  }
  return value;
};